package org.example.project.enginechat

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import org.example.project.dashboard.ContentOffset
import org.example.project.dashboard.PopupEngineCard
import org.example.project.service.ChatPopupService
import org.example.project.utils.All

@Composable
fun ChatPopupOverlayLayer(node: String) {
    val popups = ChatPopupService.getPopups(node)

    popups.forEachIndexed { index, popup ->
        PopupEngineCard(
            windowKey = popup.id,
            widthPx = 520,
            heightPx = 360,
            minWidthPx = 220,
            minHeightPx = 160,
            initialX = 300.0 + ((index % 4) * 28.0),
            initialY = 140.0 + ((index % 4) * 22.0),
            contentInsetLeft = ContentOffset.LEFT.value.toDouble(),
            contentInsetTop = ContentOffset.TOP.value.toDouble(),
            contentInsetRight = ContentOffset.RIGHT.value.toDouble(),
            contentInsetBottom = ContentOffset.BOTTOM.value.toDouble(),
            onClose = { ChatPopupService.closePopup(node, popup.id) }
        ) {
            key(popup.id) {
                ChatModuleScreen(
                    popupMode = false,
                    onClose = null,
                    embeddedInEngine = true,
                    conversationOnly = popup.aktiv,
                    presetUser = popup.userName.takeIf { it.isNotBlank() }?.let {
                        All(
                            id = popup.userName,
                            firmenId = popup.firmenId,
                            name = popup.name,
                            vorname = popup.vorname,
                            nachname = popup.nachname
                        )
                    }
                )
            }
        }
    }
}
